interface GetBarChartDomainFromMinMaxValues {
  min: number;
  max: number;
}

export const getBarChartDomainFromMinMaxValues = ({
  min,
  max,
}: GetBarChartDomainFromMinMaxValues): [number, number] => {
  if (min < 0 && max > 0) {
    return [min, max];
  }

  if (min < 0 && max <= 0) {
    return [min, 0];
  }

  return [0, max];
};
